/** Stable keys for folders a client creates itself (backend `note_folders.system_key`). */
export enum NoteFolderSystemKey {
  /** The Mac app files meeting notes here, with a subfolder per recurring meeting. */
  MEETING_RECORDINGS = 'meeting_recordings'
}
